import { Dayjs } from 'dayjs';
import { dayjs } from '../../libs/day';

export const getDayOfTheWeek = (): Array<string> => {
  const dayOfTheWeek = [];

  for (let i = 1; i <= 7; i++) {
    const day = dayjs().day(i).format('ddd').replace('.', '');

    dayOfTheWeek.push(day);
  }

  return dayOfTheWeek;
};

export const getCalendarDays = () => {
  const today = dayjs();
  const startOfWeek = today.startOf('week');
  const lastDay = today.add(15, 'days');
  const calendarDays: Dayjs[][] = [];
  let currentWeek: Dayjs[] = [];

  for (
    let currentDay = startOfWeek;
    currentDay.isSameOrBefore(lastDay, 'date');
    currentDay = currentDay.add(1, 'day')
  ) {
    currentWeek.push(currentDay);

    if (currentWeek.length === 7 || currentDay.isSame(lastDay, 'date')) {
      calendarDays.push(currentWeek);
      currentWeek = [];
    }
  }

  return { calendarDays, start: startOfWeek, end: lastDay };
};
